export const IFS_API = '/gateway/api/import';
